import { Box, styled } from "@mui/material";

export const ScheduleReportsText = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer",
  color: "#39169E",
  fontWeight: 500,
  border: "none",
  "&:hover": {
    color: "#835BFC",
    border: "none"
  }
});
